import React, { useState, useRef, useEffect } from "react";
import Navbar from "./Components/Navbar";
import Iconbox from "../../MadStack/src/assets//Group 5.png";
import CountUp from "react-countup";
import Footer from "./Components/Footer";
import initializeAOS from "./utils/aosLibrary";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import IT_image1 from "../../MadStack/src/assets/IT Staffing_1.png";
import IT_image5 from "../../MadStack/src/assets/IT Staffing_5.png";
import header from "../../MadStack/src/assets//homepageimage.png";
import team_work from "../../MadStack/src/assets//team-working-together-project.jpg";
import Cloud1 from "../../MadStack/src/assets//Cloud Solutions_1.png";
import DataSecurity from "../../MadStack/src/assets//Data Security_1.png";
import upper_arrow from "../../MadStack/src/assets//upper-arrow.svg";
import vector_2 from "../../MadStack/src/assets//vector-2.svg";
import vector_3 from "../../MadStack/src/assets//vector-3.svg";
import vector_4 from "../../MadStack/src/assets//vector-4.svg";
import dot_vector from "../../MadStack/src/assets//dot-vector.svg";
import arrow_vector from "../../MadStack/src/assets//Arrow_vector.svg";
import Win_vector from "../../MadStack/src/assets//win-vector.svg";
import service1 from "../../MadStack/src/assets//IT Staffing Vector_layerstyle.png";
import service2 from "../../MadStack/src/assets//strategic-consulting Vector 1_layerstyle.png";
import service3 from "../../MadStack/src/assets//Design - Development_v.png";
import service4 from "../../MadStack/src/assets//Digital Marketing Vector 1_layerstyle.png";
import service5 from "../../MadStack/src/assets//Cloud Solutions_v.png";
import service6 from "../../MadStack/src/assets//Database Security Vector 1_layerstyle2x.png";
import { useMediaQuery } from "@mui/material";
import EnouthTalk from "./Components/EnouthTalk";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

function LandingPage() {
  useEffect(() => {
    initializeAOS();
  }, []);
  const isXs = useMediaQuery("(min-width:768px) and (max-width:3000px)");
  const { t } = useTranslation();
  const [startCounting, setStartCounting] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounting(true);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const fontLivic = "Livvic , sans-serif";

  return (
    <>
      <Navbar />

      {/* Header Section */}
      <div
        style={{
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
        }}
      >
        <img
          src={vector_2}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-1"
          style={{
            animation: "moveUpDown 2s infinite alternate",
            position: "absolute",
            top: "130px",
          }}
        />
        <div
          style={{
            display: "flex",
            padding: isXs ? "90px 60px 100px 60px" : "90px 30px 200px 30px",
            flexDirection: isXs ? "row" : "column",
          }}
        >
          <div style={{ width: isXs ? "55%" : "100%" }}>
            <div
              data-aos="fade-down"
              style={{
                backgroundColor: "white",
                borderRadius: "25px",
                minWidth: "180px",
                maxWidth: "350px",
                width: "fit-content",
                padding: "10px 20px",
                fontSize: "18px",
                textAlign: "center",
                fontWeight: "400",
                color: "#842DDA",
                zIndex: "3",
              }}>
              {t('home_page.section_1.button_1')}
            </div>
            <h1
              data-aos="fade-right"
              style={{
                fontSize: isXs ? "64px" : "35px",
                lineHeight: "1.15",
                letterSpacing: "-0.64px",
                fontWeight: "700",
                marginBottom: "0px",
                marginTop: "30px",
              }}
            >
              {t('home_page.section_1.heading')}
            </h1>
            <div
              style={{
                fontSize: "18px",
                letterSpacing: "0.5px",
                lineHeight: "1.667",
                fontFamily: "Livvic, sans-serif",
                color: "#4A4A4A",
                paddingTop: "24px",
              }}
            >
              {t('home_page.section_1.description')}
            </div>
            <div
              data-aos="fade-up"
              style={{
                backgroundColor: "#842DDA",
                borderRadius: "25px",
                minWidth: "130px",
                maxWidth: "200px",
                padding: "13px 20px",
                fontSize: "18px",
                textAlign: "center",
                fontWeight: "400",
                color: "white",
                marginTop: "40px",
              }}
            >
              <a
                style={{ textDecoration: "none", color: "white" }}
                href="/contact-us"
              >
                {t('home_page.section_1.button_2')}
              </a>
            </div>
            <div
              data-aos="fade-up"
              style={{
                width: "90%",
                textAlign: "start",
                marginTop: "40px",
                marginLeft: "0px",
                height: "1px",
                backgroundColor: "#c4c2c2",
              }}
            ></div>
            <div
              data-aos="fade-right"
              style={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "15px",
                marginTop: "20px",
              }}
            >
              {t('home_page.section_1.experience')}
            </div>
            <div
              data-aos="fade-right"
              style={{
                fontSize: "16px",
                fontFamily: "Livvic, sans-serif",
                letterSpacing: "0.5px",
                lineHeight: "1.667",
                color: "#4A4A4A",
              }}
            >
              {t('home_page.section_1.industry_leaders')}
            </div>
          </div>

          <div
            style={{
              width: isXs ? "45%" : "100%",
              display: "flex",
              justifyContent: "center",
              paddingLeft: "0px",
              position: "relative",
              marginTop: isXs ? "0" : "30px", 
            }}
          >
            <div
              style={{
                height: isXs ? "525px" : "330px",
                width: isXs ? "525px" : "330px",
                position: "relative",
              }}
            >
              <img
                data-aos="fade-up"
                style={{
                  position: "absolute",
                  zIndex: "5",
                  objectFit: "contain",
                  objectPosition: "1px 10%",
                  top: "0",
                  left: "0",
                  height: "100%",
                  width: "100%",
                }}
                src={header}
                alt=""
              />
            </div>
            <img
              src={vector_3}
              loading="lazy"
              alt="Hero Shape Image"
              className="hero-shape-2"
              style={{
                animation: "moveUpDown 2s infinite alternate",
                position: "absolute",
                top: isXs ? "450px" : "410px",
                left: isXs ? "330px" : "240px",
              }}
            />
            <img
              src={upper_arrow}
              loading="lazy"
              alt="Hero Shape Image"
              className="hero-shape-2"
              style={{
                animation: "moveUpDown 1.5s infinite alternate",
                position: "absolute",
                top: isXs ? "320px" : "220px",
                left: "-17px",
                zIndex: "5",
              }}
            />
          </div>
        </div>
      </div>

      {/* 2nd Section */}
      <div
        style={{
          display: "flex",
          gap: "5rem",
          // height: isXs ? "auto" : "auto",
          padding: isXs ? "60px 60px" : "30px 10px",
          flexDirection: isXs ? "row" : "column",
        }}
      >
        <div
          style={{
            width: "50%",
            position: "relative",
            paddingTop: "100px",
            display: isXs ? "" : "none",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              position: "absolute",
              right: "80px",
              top: "20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ fontSize: "45px ", fontWeight: "600", color: "#842DDA" }}>20 +</div>
            <div style={{ fontSize: "20px", fontWeight: "600", color: "#842DDA" }}>Years of experience</div>
          </div> */}
          <img width={500} style={{}} src={IT_image5} alt="" />

          <img
            data-aos="fade-up"
            src={dot_vector}
            loading="lazy"
            alt="Hero Shape Image"
            className="hero-shape-2"
            style={{
              animation: "moveUpDown 2s infinite alternate",
              position: "absolute",
              top: "500px",
              left: "40px",
            }}
          />

          <img
            src={arrow_vector}
            loading="lazy"
            alt="Hero Shape Image"
            className="hero-shape-2"
            style={{
              animation: "moveUpDown 2s infinite alternate",
              position: "absolute",
              top: "560px",
              left: "0px",
            }}
          />
        </div>
        <div
          style={{
            width: isXs ? "50%" : "100%",
            paddingLeft: "20px",
            marginTop: isXs ? "" : "30px",
          }}
        >
          <div
            data-aos="fade-down"
            style={{
              backgroundColor: "#F1F1F1",
              borderRadius: "25px",
              minWidth: "180px",
              width: "fit-content",
              maxWidth: "250px",
              padding: "10px 20px",
              fontSize: "16px",
              textAlign: "center",
              fontWeight: "400",
              color: "black",
              marginBottom: "40px",
              marginTop: isXs ? "" : "30px",
            }}
          >
            {t('home_page.section_2.button_1')} MadStack
          </div>
          <h2
            data-aos="fade-left"
            style={{
              letterSpacing: "-0.48px",
              fontSize: isXs ? "48px" : "30px",
              fontWeight: "700",
              lineHeight: "1.25",
            }}
          >
            {t('home_page.section_2.heading')}
          </h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              marginTop: isXs ? "" : "30px",
            }}
          >
            <div
              data-aos="fade-right"
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "start",
                marginTop: isXs ? "20px" : "2 0px",
              }}
            >
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('home_page.section_2.content', { returnObjects: true })[0]['heading']}
                  {/* Strategic Technology Advising */}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('home_page.section_2.content', { returnObjects: true })[0]['description']}

                </div>
              </div>
            </div>
            <div data-aos="fade-left" style={{ display: "flex", gap: "10px" }}>
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('home_page.section_2.content', { returnObjects: true })[1]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('home_page.section_2.content', { returnObjects: true })[1]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-right" style={{ display: "flex", gap: "10px" }}>
              <div>
                <img style={{ height: "25px" }} src={Iconbox} alt="" />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    letterSpacing: "-0.18",
                    lineHeight: "1",
                  }}
                >
                  {t('home_page.section_2.content', { returnObjects: true })[2]['heading']}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('home_page.section_2.content', { returnObjects: true })[2]['description']}
                </div>
              </div>
            </div>
            <div
              data-aos="fade-down"
              style={{
                backgroundColor: "#842DDA",
                borderRadius: "25px",
                width: "150px",
                padding: "10px 15px",
                fontSize: "18px",
                textAlign: "center",
                fontWeight: "400",
                color: "white",
              }}
            >

              <Link
                style={{ textDecoration: "none", color: "white" }}
                to="/about-us"
              >
                {t('home_page.section_2.button')}
                {/* Learn more */}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* 3rd section */}

      <div
        style={{
          padding: isXs ? "90px 60px" : "80px 20px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, 0.2) 1.74%, rgba(228, 250, 242, 0.2) 39.85%, rgba(211, 243, 207, 0.2) 73.94%, rgba(255, 243, 228, 0.2) 98.01%)",
        }}
      >
        <div style={{ padding: "0px 0px 40px 0px" }}>
          <div
            data-aos="fade-down"
            style={{
              backgroundColor: "#F1F1F1",
              borderRadius: "25px",
              width: "180px",
              padding: "10px 15px",
              fontSize: "18px",
              textAlign: "center",
              fontWeight: "400",
              color: "black",
            }}
          >
            {t('home_page.section_3.button')}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: isXs ? "row" : "column",
            marginBottom: "50px",
          }}
        >
          <h2
            data-aos="fade-right"
            style={{
              fontSize: isXs ? "48px" : "40px",
              fontWeight: "600",
              margin: "0px",
              width: isXs ? "50%" : "100%",
              paddingLeft: isXs ? "20px" : "0px",
            }}
          >
            {t('home_page.section_3.heading')}

          </h2>
          <div
            data-aos="fade-left"
            style={{
              fontFamily: fontLivic,
              width: isXs ? "50%" : "100%",
              lineHeight: "1.8",
              marginTop: "15px",
            }}
          >
            {t('home_page.section_3.description')}
          </div>
        </div>

        <div
          className="flip-card-container"
          style={{
            display: "grid",
            gridTemplateColumns: isXs
              ? "repeat(3, 1fr)"
              : " repeat(1, minmax(0, 1fr))",
            maxWidth: "100%",
            rowGap: "30px",
            justifyItems: "center",
          }}
        >
          <div className="flip-card ">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="content">
                  <div className="card-title">
                    <img style={{ height: "88px" }} src={service1} alt="" />
                  </div>
                  <div className="card-heading">{t('home_page.section_3.services', { returnObjects: true })[0]['name']}</div>
                </div>

                <div className="description">
                  {t('home_page.section_3.services', { returnObjects: true })[0]['description']}
                </div>
              </div>
              <div className="flip-card-back">
                <img style={{ height: "88px" }} src={service1} alt="" />
                <div className="card-details">{t('home_page.section_3.services', { returnObjects: true })[0]['name']}</div>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="/services/it-staffing"
                >
                  <div className="card-arrow">
                    {t('home_page.section_7.button')} <ArrowOutwardIcon />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="content">
                  <div className="card-title">
                    <img style={{ height: "88px" }} src={service2} alt="" />
                  </div>
                  <div className="card-heading">{t('home_page.section_3.services', { returnObjects: true })[1]['name']}</div>
                </div>

                <div className="description">
                  {t('home_page.section_3.services', { returnObjects: true })[1]['description']}
                </div>
              </div>
              <div className="flip-card-back">
                <img style={{ height: "88px" }} src={service2} alt="" />
                <div className="card-details">{t('home_page.section_3.services', { returnObjects: true })[1]['name']}</div>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="/services/strategic-consulting"
                >

                  <div className="card-arrow">
                    {t('home_page.section_7.button')} <ArrowOutwardIcon />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="content">
                  <div className="card-title">
                    <img style={{ height: "88px" }} src={service3} alt="" />
                  </div>
                  <div className="card-heading">{t('home_page.section_3.services', { returnObjects: true })[2]['name']}</div>
                </div>

                <div className="description">
                  {t('home_page.section_3.services', { returnObjects: true })[2]['description']}
                </div>
              </div>
              <div className="flip-card-back">
                <img style={{ height: "88px" }} src={service3} alt="" />
                <div className="card-details">{t('home_page.section_3.services', { returnObjects: true })[2]['name']}</div>
                <a
                  href="/services/design-development"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <div className="card-arrow">
                    {t('home_page.section_7.button')} <ArrowOutwardIcon />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="content">
                  <div className="card-title">
                    <img style={{ height: "88px" }} src={service4} alt="" />
                  </div>
                  <div className="card-heading">{t('home_page.section_3.services', { returnObjects: true })[3]['name']}</div>
                </div>

                <div className="description">
                  {t('home_page.section_3.services', { returnObjects: true })[3]['description']}
                </div>
              </div>
              <div className="flip-card-back">
                <img style={{ height: "88px" }} src={service4} alt="" />
                <div className="card-details">{t('home_page.section_3.services', { returnObjects: true })[3]['name']}</div>
                <a
                  href="/services/digital-marketing"
                  style={{ textDecoration: "none", color: "black" }}
                >

                  <div className="card-arrow">
                    {t('home_page.section_7.button')} <ArrowOutwardIcon />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="content">
                  <div className="card-title">
                    <img style={{ height: "88px" }} src={service5} alt="" />
                  </div>
                  <div className="card-heading">{t('home_page.section_3.services', { returnObjects: true })[4]['name']}</div>
                </div>

                <div className="description">
                  {t('home_page.section_3.services', { returnObjects: true })[4]['description']}
                </div>
              </div>
              <div className="flip-card-back">
                <img style={{ height: "88px" }} src={service5} alt="" />
                <div className="card-details">{t('home_page.section_3.services', { returnObjects: true })[4]['name']}</div>
                <a
                  href="/services/cloud-solutions"
                  style={{ textDecoration: "none", color: "black" }}
                >

                  <div className="card-arrow">
                    {t('home_page.section_7.button')} <ArrowOutwardIcon />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="content">
                  <div className="card-title">
                    <img style={{ height: "88px" }} src={service6} alt="" />
                  </div>
                  <div className="card-heading">{t('home_page.section_3.services', { returnObjects: true })[5]['name']}</div>
                </div>

                <div className="description">
                  {t('home_page.section_3.services', { returnObjects: true })[5]['description']}
                </div>
              </div>
              <div className="flip-card-back">
                <img style={{ height: "88px" }} src={service6} alt="" />
                <div className="card-details">{t('home_page.section_3.services', { returnObjects: true })[5]['name']}</div>
                <a
                  href="/services/database-security"
                  style={{ textDecoration: "none", color: "black" }}
                >

                  <div className="card-arrow">
                    {t('home_page.section_7.button')} <ArrowOutwardIcon />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 4th section */}

      <div
        style={{
          display: "flex",
          flexDirection: isXs ? "row" : "column-reverse",
          padding: isXs ? "90px 60px" : "90px 20px",
          paddingBottom: isXs ? "90px" : "350px",
        }}
      >
        <div
          style={{
            width: isXs ? "50%" : "100%",
            position: "relative",
            paddingTop: "100px",
          }}
        >
          <div
            data-aos="fade-down-right"
            style={{ zIndex: "1", display: isXs ? "flex" : "none" }}
          >
            <img style={{}} src={vector_4} alt="" />
          </div>
          <div
            data-aos="fade-up-left"
            style={{
              position: "absolute",
              top: isXs ? "170px" : "20px",
              left: isXs ? "80px" : "20px",
              height: isXs ? "423px" : "330px",
              width: isXs ? "410px" : "330px",
            }}
          >
            <img
              style={{
                borderRadius: "80px 30px 30px 70px",
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}
              src={team_work}
              alt=""
            />
          </div>
          <div
            style={{
              animation: "moveUpDown 2s infinite alternate",
              display: "flex",
              gap: "20px",
              position: "absolute",
              top: isXs ? "565px" : "315px",
              backgroundColor: "white",
              left: isXs ? "170px" : "50px",
              maxWidth: "240px",
              borderRadius: "32px 12px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, .1)",
              padding: "14px 22px 14px 14px",
            }}
          >
            <div>
              <img src={Win_vector} alt="" />
            </div>
            <div>{t('home_page.section_4.float_btn')}</div>
          </div>
        </div>

        <div style={{ width: isXs ? "50%" : "100%" }}>
          <div
            data-aos="fade-down"
            style={{
              backgroundColor: "#F1F1F1",
              borderRadius: "25px",
              width: "fit-content",
              minWidth: "180px",
              maxWidth: "280px",
              padding: "10px 20px",
              fontSize: "18px",
              textAlign: "center",
              fontWeight: "400",
              color: "black",
              marginBottom: "40px",
            }}
          >
            {t('home_page.section_4.button')}
          </div>
          <h2
            data-aos="fade-right"
            style={{
              letterSpacing: "-0.98px",
              fontSize: isXs ? "48px" : "40px",
              fontWeight: "700",
              lineHeight: "1.25",
            }}
          >
            {t('home_page.section_4.heading')}
            {/* Mastering Complex IT Challenges with Expertise */}
          </h2>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "30px" }}
          >
            <div style={{ display: "flex", gap: "10px", alignItems: "start" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  data-aos="fade-up"
                  style={{
                    fontSize: "16px",
                    fontFamily: "Livvic , sans-serif",
                    letterSpacing: "0.5px",
                    lineHeight: "1.667",
                    color: "#4A4A4A",
                  }}
                >
                  {t('home_page.section_4.description')}

                </div>
              </div>
            </div>
          </div>
          <div
            style={{ marginTop: "20px" }}
            className="accordion"
            id="accordionExample"
          >
            <div data-aos="fade-up" className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <div
                  className="accordion-button"
                  type="button"
                  style={{ fontWeight: "600", paddingLeft: "0px" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[0]['heading']}
                  {/* Expertise You Can Trust */}
                </div>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: fontLivic, fontSize: "16px" }}
                  className="accordion-body"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[0]['description']}

                </div>
              </div>
            </div>
            <div data-aos="fade-up" className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <div
                  className="accordion-button collapsed"
                  type="button"
                  style={{ fontWeight: "600", paddingLeft: "0px" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[1]['heading']}
                </div>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: fontLivic, fontSize: "16px" }}
                  className="accordion-body"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[1]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-up" className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <div
                  className="accordion-button collapsed"
                  type="button"
                  style={{ fontWeight: "600", paddingLeft: "0px" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[2]['heading']}
                </div>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: fontLivic, fontSize: "16px" }}
                  className="accordion-body"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[2]['description']}
                </div>
              </div>
            </div>
            <div data-aos="fade-up" className="accordion-item">
              <h2 className="accordion-header" id="headingForth">
                <div
                  className="accordion-button collapsed"
                  type="button"
                  style={{ fontWeight: "600", paddingLeft: "0px" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseForth"
                  aria-expanded="false"
                  aria-controls="collapseForth"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[3]['heading']}
                </div>
              </h2>
              <div
                id="collapseForth"
                className="accordion-collapse collapse"
                aria-labelledby="headingForth"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: fontLivic, fontSize: "16px" }}
                  className="accordion-body"
                >
                  {t('home_page.section_4.content', { returnObjects: true })[3]['description']}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Counter Section */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          gap: isXs ? "60px" : "10px",
          alignItems: "center",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          height: isXs ? "200px" : "auto",
          padding: isXs ? "" : "30px",
          flexDirection: isXs ? "row" : "column",
        }}
        ref={sectionRef}
      >
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div>
              {startCounting && (
                <CountUp
                  style={{
                    fontSize: isXs ? "50px" : "30px",
                    fontWeight: "bold",
                  }}
                  end={30}
                  duration={5}
                  separator=","
                />
              )}
            </div>
            <div
              style={{ fontSize: isXs ? "50px" : "30px", fontWeight: "bold" }}
            >
              +
            </div>
          </div>
          <div style={{ fontSize: "16px", fontFamily: fontLivic }}>
            {t('home_page.section_5.text_1')}
          </div>
        </div>
        <div
          style={{
            width: isXs ? "70px" : "0px",
            height: "1px",
            backgroundColor: "#c4c2c2",
            marginLeft: "0px",
            transform: "rotate(90deg)",
            textAlign: "start",
          }}
        ></div>

        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div>
              {startCounting && (
                <CountUp
                  style={{
                    fontSize: isXs ? "50px" : "30px",
                    fontWeight: "bold",
                  }}
                  end={40}
                  duration={5}
                  separator=","
                />
              )}
            </div>
            <div
              style={{ fontSize: isXs ? "50px" : "30px", fontWeight: "bold" }}
            >
              +
            </div>
          </div>
          <div style={{ fontSize: "16px", fontFamily: fontLivic }}>
            {t('home_page.section_5.text_2')}
          </div>
        </div>
        <div
          style={{
            width: isXs ? "70px" : "0px",
            height: "1px",
            backgroundColor: "#c4c2c2",
            marginLeft: "0px",
            transform: "rotate(90deg)",
            textAlign: "start",
          }}
        ></div>
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div>
              {startCounting && (
                <CountUp
                  style={{
                    fontSize: isXs ? "50px" : "30px",
                    fontWeight: "bold",
                  }}
                  end={65}
                  duration={5}
                  separator=","
                />
              )}
            </div>
            <div
              style={{ fontSize: isXs ? "50px" : "30px", fontWeight: "bold" }}
            >
              %
            </div>
          </div>
          <div style={{ fontSize: "16px", fontFamily: fontLivic }}>
            {t('home_page.section_5.text_3')}
          </div>
        </div>
        <div
          style={{
            width: isXs ? "70px" : "0px",
            height: "1px",
            backgroundColor: "#c4c2c2",
            marginLeft: "0px",
            transform: "rotate(90deg)",
            textAlign: "start",
          }}
        ></div>
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div>
              {startCounting && (
             <CountUp
             style={{
               fontSize: isXs ? "50px" : "30px",
               fontWeight: "bold",
             }}
             end={4.9}
             duration={5}
             separator=","
             decimals={1} // Ensures 1 decimal place is shown
           />
              )}
            </div>
            {/* <div
              style={{ fontSize: isXs ? "50px" : "30px", fontWeight: "bold" }}
            >
              +
            </div> */}
          </div>
          <div style={{ fontSize: "16px", fontFamily: fontLivic }}>
            {t('home_page.section_5.text_4')}
          </div>
        </div>
      </div>
      {/* 5th Section */}

      <EnouthTalk />

      {/* 6th section */}
      <div
        style={{ padding: isXs ? "0px 50px 90px 60px" : "0px 20px 80px 20px" }}
      >
        <div style={{ padding: "0px 0px 40px 0px" }}>
          <div
            data-aos="fade-down"
            style={{
              backgroundColor: "#F1F1F1",
              borderRadius: "25px",
              width: "180px",
              padding: "10px 15px",
              fontSize: "18px",
              textAlign: "center",
              fontWeight: "400",
              color: "black",
            }}
          >
            {t('home_page.section_6.button')}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginBottom: "50px",
            flexDirection: isXs ? "row" : "column",
          }}
        >
          <h2
            data-aos="fade-right"
            style={{
              fontSize: isXs ? "48px" : "40px",
              fontWeight: "600",
              // marginLeft:isXs ?  "20px":"0px",
              width: isXs ? "50%" : "100%",
              paddingRight: isXs ? "100px" : "0px",
            }}
          >
            {t('home_page.section_6.heading')}
            {/* Read Our Latest <br style={{ display: isXs ? "flex" : "none" }} />
            News and Insights */}
          </h2>
          <div
            data-aos="fade-left"
            style={{
              fontFamily: fontLivic,
              width: isXs ? "50%" : "100%",
              lineHeight: "1.8",
              marginTop: "15px",
            }}
          >
            {t('home_page.section_6.description')}
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isXs
              ? "repeat(3, 1fr)"
              : "repeat(1, minmax(0, 2fr))",
            rowGap: isXs ? "0px" : "20px",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <div
            data-aos="fade-up"
            style={{
              height: "auto",
              width: isXs ? "370px" : "auto",
              borderRadius: "30px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              overflow: "hidden",
              border: "1px solid grey",
            }}
          >
            <div style={{ backgroundColor: "#f2f2f2" }}>
              <img
                src={IT_image1}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectPosition: "center",
                }}
              />
            </div>
            <div>
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  padding: "0px 20px",
                  marginTop: "10px",
                  height: "80px",

                }}
              >
                {t('home_page.section_7.blog_headings', { returnObjects: true })[0]['heading']}
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // marginTop: "10px",
              }}
            >
              <div
                style={{
                  width: "90%",
                  height: "1px",
                  backgroundColor: "#BFC7D2",
                  marginBottom: 0,
                }}
              ></div>
            </div>

            <div
              style={{
                padding: "0px 30px 10px 30px",
                display: "flex",
                fontFamily: fontLivic,
                justifyContent: "space-between",
                alignItems: "center",
                // border: "1px solid red"
              }}
            >
              <div>Oct 10, 2024</div>
              <div>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="/blog/it-stafing"
                >
                  {t('home_page.section_7.button')} <ArrowOutwardIcon />
                </a>
              </div>
            </div>
          </div>

          <div
            data-aos="fade-down"
            style={{
              height: "auto",
              width: isXs ? "370px" : "auto",
              borderRadius: "30px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              overflow: "hidden",
              border: "1px solid grey",
            }}
          >
            <div style={{ backgroundColor: "#f2f2f2" }}>
              <img
                src={DataSecurity}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>
            <div>
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  padding: "0px 20px",
                  marginTop: "10px",
                  height: "80px"
                }}
              >
                {t('home_page.section_7.blog_headings', { returnObjects: true })[1]['heading']}
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  width: "90%",
                  height: "1px",
                  backgroundColor: "#BFC7D2",
                }}
              ></div>
            </div>
            <div
              style={{
                padding: "0px 30px 10px 30px",
                display: "flex",
                fontFamily: fontLivic,
                justifyContent: "space-between",
              }}
            >
              <div>Oct 19, 2024</div>
              <div>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="/blog/database-security"
                >
                  {t('home_page.section_7.button')} <ArrowOutwardIcon />
                </a>
              </div>
            </div>
          </div>

          <div
            data-aos="fade-up"
            style={{
              maxHeight: "520px",
              minHeight: "420px",
              width: isXs ? "370px" : "auto",
              borderRadius: "30px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              overflow: "hidden",
              border: "1px solid grey",
            }}
          >
            <div style={{ backgroundColor: "#f2f2f2" }}>
              <img
                src={Cloud1}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>
            <div>
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  padding: "0px 20px",
                  marginTop: "10px",
                  height: "80px"
                }}
              >
                {t('home_page.section_7.blog_headings', { returnObjects: true })[2]['heading']}

              </h3>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  width: "90%",
                  height: "1px",
                  backgroundColor: "#BFC7D2",
                }}
              ></div>
            </div>
            <div
              style={{
                padding: "0px 30px 10px 30px",
                display: "flex",
                fontFamily: fontLivic,
                justifyContent: "space-between",
              }}
            >
              <div>Oct 15, 2024</div>
              <div>

                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="/blog/cloud-infrastructure"
                >
                  {t('home_page.section_7.button')} <ArrowOutwardIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer
        position="top-right" // You can change the position
        autoClose={5000} // You can change the auto close time
        padding="15px"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default LandingPage;
